import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface IBotTitleMessage {
  readonly id: string;
  readonly title: string;
  readonly rm: boolean;
  readonly nodeId: string;
  readonly icon?: 'flag' | 'info' | 'alert' | 'warning' | 'success';
  readonly type: MESSAGES.TITLE_BOT_MESSAGE;
  readonly role: ROLE;
  // TODO: deprecated in Chatbot V2, remove when merging the experiment
  readonly avatar: boolean;
  readonly preventScroll?: boolean;
}

export const createTitleBotMessage = (data): IBotTitleMessage => ({
  id: data.id || uuid(),
  title: data.title,
  rm: Boolean(data.rm),
  nodeId: data.nodeId,
  icon: data.icon,
  type: MESSAGES.TITLE_BOT_MESSAGE,
  role: ROLE.BOT,
  avatar: true,
  preventScroll: Boolean(data.preventScroll),
});
